import { render } from "./DataRow.vue?vue&type=template&id=78bf6e64&scoped=true"
import script from "./DataRow.vue?vue&type=script&lang=js"
export * from "./DataRow.vue?vue&type=script&lang=js"

import "./DataRow.vue?vue&type=style&index=0&id=78bf6e64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78bf6e64"]])

export default __exports__